import classNames from 'classnames';
import React, { ChangeEvent, CSSProperties, FC } from 'react';

interface ISwitchProps {
  size?: SwitchSize;
  type?: SwitchType | string;
  name?: string;
  value?: string;
  onChange: (name: string, value: boolean) => void;
  isDisabled?: boolean;
  checked?: boolean;
  defaultChecked?: boolean;
  style?: CSSProperties;
}

export enum SwitchType {
  ROUNDED = 'rounded',
  STRIPPED = 'stripped',
}

export enum SwitchSize {
  LARGE = 'large',
  MIDDLE = 'middle',
  SMALL = 'small',
}

type Props = ISwitchProps;

export const Switch: FC<Props> = ({
  value,
  checked,
  name,
  isDisabled,
  onChange,
  style,
  type = SwitchType.STRIPPED,
  size = SwitchSize.SMALL,
  defaultChecked,
}) => (
  <label
    htmlFor={name}
    tabIndex={0}
    className={classNames('switchLabel', {
      checked: checked,
      disabled: isDisabled,
      large: size === SwitchSize.LARGE,
      middle: size === SwitchSize.MIDDLE,
      rounded: type === SwitchType.ROUNDED,
    })}
    style={style}
  >
    <input
      tabIndex={-1}
      type='checkbox'
      role='switch'
      name={name}
      checked={checked}
      defaultChecked={defaultChecked}
      value={value}
      onChange={(e: ChangeEvent<HTMLInputElement>) => onChange(e.currentTarget.name, e.currentTarget.checked)}
      className={'switchInput'}
      id={name}
      disabled={isDisabled}
    />
    <span className={'switchSlider'} />
    <span className={'switchHandle'} />
  </label>
);
